import * as types from '@/store/types'
import {createMission} from '@/api/mission'

const state = {
}

const actions = {
  async createMission ({commit}, data) {
    commit(types.MISSION__CREATE_INIT)
    try {
      //await createMission(data)
      commit(types.MISSION__CREATE_SUCCESS)
    } catch (err) {
      const errors = err.response ? err.response.data : err
      commit(types.MISSION__CREATE_FAILURE, errors)
    }
  }
}

const mutations = {
  [types.MISSION__CREATE_INIT] () {
    // console.log('Creating mission...')
  },
  [types.MISSION__CREATE_SUCCESS] () {
    // console.log('Mission created')
  },
  [types.MISSION__CREATE_FAILURE] (_, errors) {
    console.error('Failed to create mission:')
    console.error(errors)
  }
}

export default {
  state,
  actions,
  mutations
}
